/*global angular, google*/
'use strict';

angular.module('MrDWebApp').controller('MapCtrl', function ($scope) {


});
